module.exports = __webpack_public_path__ + "img/webinar.1efa3e3c.jpeg";